import { IllegalArgumentError } from 'faro-common-model';
import { TimeUnit } from './time-unit.js';
import { z } from 'zod';
export const epochTimeUnitSchema = z.enum([TimeUnit.day, TimeUnit.week]);
export const epochDaysMaxValue = 7305;
export const epochDurationSchema = z.object({
    timeUnit: epochTimeUnitSchema,
    days: z.number().int().min(1).max(epochDaysMaxValue),
});
export function toEpochDuration(epochDuration) {
    const result = epochDurationSchema.safeParse(epochDuration);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid EpochDuration object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=epoch-duration.js.map